import { RuleParamSchema } from "vee-validate/dist/types/types";
import { isUndefinedOrNullOrEmptyString } from "@/module/Validation/rules/isUndefinedOrNullOrEmptyString";

const countriesWithCustomZip: { [key: string]: string } = {
  JM: "^JM[A-D]{1}[A-Za-z]{2}\\d{2}$",
};

const validate = async (
  value: any,
  { country }: Record<string, any>,
): Promise<boolean> => {
  if (isUndefinedOrNullOrEmptyString(value)) {
    return false;
  }

  if (country === undefined) {
    return false;
  }

  value = String(value);
  country = country.toUpperCase().split("-")[0];

  const postalCodes = await import(
    // @ts-ignore
    /* webpackChunkName: "zip-validation" */ "postal-codes-js"
  );

  if (postalCodes.validate(country, value) === true) {
    return true;
  }

  if (!countriesWithCustomZip.hasOwnProperty(country)) {
    return false;
  }

  return new RegExp(countriesWithCustomZip[country]).test(value);
};

const params: RuleParamSchema[] = [
  {
    name: "country",
  },
];

export { validate, params };

export default {
  validate,
  params,
};
